export const QueryKey = {
  CONSENT_PROFILE: 'CONSENT_PROFILE',
  CONSENT_PROFILE_V2: 'CONSENT_PROFILE_V2',
  SDK_TOKEN: 'SDK_TOKEN',
  NON_SDK_TOKEN: 'NON_SDK_TOKEN',
  REQUEST_CONFIG: 'REQUEST_CONFIG',
  PREFERENCE_DETAILS: 'PREFERENCE_DETAILS',
  DOWNLOAD_CONSENT_RECORD_LOGS: 'DOWNLOAD_CONSENT_RECORD_LOGS',
  OTP_CONFIG: 'OTP_CONFIG',
  DOWNLOAD_NOTICE_AND_RECORD: 'DOWNLOAD_NOTICE_AND_RECORD',
  DOWNLOAD_CONSENT_NOTICE: 'DOWNLOAD_CONSENT_NOTICE',
  REQUEST_RECORDS: 'REQUEST_RECORDS',
  REQUEST_RECORD_BY_ID: 'REQUEST_RECORD_BY_ID',
  REQUEST_RESPONSES: 'REQUEST_RESPONSES',
  REQUEST_RECORDS_STATUS_HISTORY: 'REQUEST_RECORDS_STATUS_HISTORY',
  RECORD_CLIENT_DATA_AND_MAPPINGS: 'RECORD_CLIENT_DATA_AND_MAPPINGS',
  EUP_CLIENT_META_DATA: 'EUP_CLIENT_META_DATA',

  COOKIE_CLIENT_PROFILE: 'COOKIE_CLIENT_PROFILE',
  COOKIE_GROUP_BY_CATEGORY: 'COOKIE_GROUP_BY_CATEGORY',
  COOKIE_RECORDS: 'COOKIE_RECORDS',
  PROFILE_NOTIFICATION_CONFIG: 'PROFILE_NOTIFICATION_CONFIG',

  PUBLIC_ASSESSMENT: 'PUBLIC_ASSESSMENT',
  FETCH_ASSESSMENT_NESTED_QUESTION: 'FETCH_ASSESSMENT_NESTED_QUESTION',
  ASSESSMENT_QUESTION_COMMENTS: 'ASSESSMENT_QUESTION_COMMENTS',
  PUBLIC_FEEDBACK: 'PUBLIC_FEEDBACK',
};

export const Events = {
  IFRAME_READY: 'IFRAME_READY',
  CONFIG_FROM_SDK: 'CONFIG_FROM_SDK',
  CLOSE_IFRAME: 'CLOSE_IFRAME',
  COMMUNICATE_RESPONSE: 'COMMUNICATE_RESPONSE',
  COOKIE_DATA_UPDATE: 'COOKIE_DATA_UPDATE',
  LOCALE_CHANGE: 'LOCALE_CHANGE',
  RESIZE_IFRAME: 'RESIZE_IFRAME',
};

export const ApiEndPoints = {
  LOGOUT_USER: '/auth/logout',
  FETCH_USER_PROFILE: '/auth/user-profile',
  FETCH_SDK_TOKEN: 'consent-runner/api/v1/auth/sdkLogin',
  FETCH_NON_SDK_AUTH_TOKEN: 'consent-runner/api/v1/auth/login/{token}',
  FETCH_CONSENT_PROFILES: '/consent-runner/details/signed',
  COLLECT_CONSENT: '/consent-runner/collect/signed',
  FETCH_REQUEST_CONFIG: '/consent-runner/request/signed',
  FETCH_PREFERENCE_CONFIG: '/consent-runner/preference/signed',
  FETCH_OTP_CONFIG: '',

  FETCH_PRINCIPAL_GROUPS: '/consent-runner/api/v1/end-user/principal-groups',
  FETCH_PRINCIPAL_GROUP_DETAILS: '/consent-runner/api/v1/end-user/principal-groups/{principalGroupId}',
  FETCH_REQUEST_RECORDS: '/consent-runner/api/v1/end-user/request-records',
  FETCH_REQUEST_RECORD_BY_ID: '/consent-runner/api/v1/request-records/{requestId}',

  FETCH_REQUEST_RESPONSES_PUBLIC: '/consent-runner/request-record/response/signed',
  ADD_REQUEST_RESPONSES: '/consent-runner/api/v1/end-user/request-response',
  FETCH_REQUEST_RESPONSES: '/consent-runner/api/v1/end-user/request-response',
  FETCH_REQUEST_STATUS_HISTORY: '/consent-manager/v1/request-records/history/{requestId}',
  FETCH_CONSENT_RECORD_CLIENT_DATA_AND_MAPPINGS: '/consent-manager/v1/consent-profiles/mapping-details/{consentProfileId}',
  GET_REQUEST_CONFIG: '/consent-runner/api/v1/end-user/request-config',
  FETCH_CLIENT_META_DATA: '/consent-runner/api/v1/end-user/client-metadata',

  FETCH_COOKIE_CLIENT_PROFILE: '/cookie-manager/v1/profile/client/{id}',
  FETCH_COOKIE_GROUP_BY_CATEGORY: '/cookie-manager/v1/domain/{domainId}/cookies/group-by-category',
  CREATE_COOKIE_RECORD: '/cookie-manager/v1/record',
  PRINCIPAL_GROUP_NOTIF_CONFIG: '/consent-runner/api/v1/end-user/principal-groups/{principalGroupId}/notification-configuration',
  FETCH_PUBLIC_ASSESSMENT: '/consent-risk-management/v1/assessment/{assessmentId}',
  FETCH_ASSESSMENT_NESTED_QUESTION: '/consent-risk-management/v1/assessment/{assessmentId}/assessment-question/{id}/answer/{answerId}',
  FETCH_ASSESSMENT_QUESTION_ALL_RESPONSES: '/consent-risk-management/v1/assessment/{assessmentId}/assessment-question/{id}/conversation/responses',
  CREATE_ASSESSMENT_QUESTION_RESPONSE: '/consent-risk-management/v1/assessment/{assessmentId}/assessment-question/{id}/conversation/responses',
  GET_ASSESSMENT_QUESTION_FILE_PRESIGNED_URL: '/consent-risk-management/v1/assessment/{assessmentId}/assessment-question/{id}/upload-presigned-url',
  FETCH_FEEDBACK_FORM: '/consent-runner/feedback/signed',
};

// Ordered by number of speakers (2011 census, descending), with English
// pinned at the top. Insertion order = display order — `Object.values(...)`
// and filtered `verifiedLocales.map(code => Languages[code])` both yield
// this order without additional sort logic.
export const Languages = {
  EN_IN: {
    locale: 'EN_IN',
    label: 'English',
  },
  HI_IN: {
    locale: 'HI_IN',
    label: 'हिन्दी (Hindi)',
  },
  BN_IN: {
    locale: 'BN_IN',
    label: 'বাংলা (Bengali)',
  },
  MR_IN: {
    locale: 'MR_IN',
    label: 'मराठी (Marathi)',
  },
  TE_IN: {
    locale: 'TE_IN',
    label: 'తెలుగు (Telugu)',
  },
  TA_IN: {
    locale: 'TA_IN',
    label: 'தமிழ் (Tamil)',
  },
  GU_IN: {
    locale: 'GU_IN',
    label: 'ગુજરાતી (Gujarati)',
  },
  UR_IN: {
    locale: 'UR_IN',
    label: 'اردو (Urdu)',
  },
  KN_IN: {
    locale: 'KN_IN',
    label: 'ಕನ್ನಡ (Kannada)',
  },
  OD_IN: {
    locale: 'OD_IN',
    label: 'ଓଡ଼ିଆ (Odia)',
  },
  ML_IN: {
    locale: 'ML_IN',
    label: 'മലയാളം (Malayalam)',
  },
  PA_IN: {
    locale: 'PA_IN',
    label: 'ਪੰਜਾਬੀ (Punjabi)',
  },
  AS_IN: {
    locale: 'AS_IN',
    label: 'অসমীয়া (Assamese)',
  },
  MAI_IN: {
    locale: 'MAI_IN',
    label: 'मैथिली (Maithili)',
  },
  SAT_IN: {
    locale: 'SAT_IN',
    label: 'ᱥᱟᱱᱛᱟᱲᱤ (Santali)',
  },
  KS_IN: {
    locale: 'KS_IN',
    label: 'کٲشُر (Kashmiri)',
  },
  NE_IN: {
    locale: 'NE_IN',
    label: 'नेपाली (Nepali)',
  },
  SD_IN: {
    locale: 'SD_IN',
    label: 'سنڌي (Sindhi)',
  },
  DOI_IN: {
    locale: 'DOI_IN',
    label: 'डोगरी (Dogri)',
  },
  KOK_IN: {
    locale: 'KOK_IN',
    label: 'कोंकणी (Konkani)',
  },
  MNI_IN: {
    locale: 'MNI_IN',
    label: 'ꯃꯤꯇꯩꯂꯣꯟ (Manipuri)',
  },
  BRX_IN: {
    locale: 'BRX_IN',
    label: 'बर` (Bodo)',
  },
  SA_IN: {
    locale: 'SA_IN',
    label: 'संस्कृतम् (Sanskrit)',
  },
};

export const DEFAULT_LOCALE = Languages.EN_IN.locale;

export const Ids = {
  ONE_TIME_NOTICE: 'ONE_TIME_NOTICE',
  CONSENT: 'CONSENT',
  REQUEST_CENTER: 'REQUEST_CENTER',
  PREFERENCE_CENTER: 'PREFERENCE_CENTER',
  ACCESS: 'ACCESS',
  ERASURE: 'ERASURE',
  GRIEVANCE: 'GRIEVANCE',
  NOMINATION: 'NOMINATION',
  UPDATION: 'UPDATION',
  FIELD_OTHER: 'OTHER',
  REQUEST_NEW_REQUEST: 'REQUEST_NEW_REQUEST',
  REQUEST_ID: 'REQUEST_ID',
  REQUEST_TYPE: 'REQUEST_TYPE',
  STATUS: 'STATUS',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
  VIEW_REQUEST: 'VIEW_REQUEST',
  CANCEL_REQUEST: 'CANCEL_REQUEST',
  VIEW_COMMUNICATIONS: 'VIEW_COMMUNICATIONS',
};

export const uiTargetViews = {
  NOTIFICATION: 'NOTIFICATION',
  WEB_VIEW: 'WEB_VIEW',
};

export const consentProfileTypes = {
  CONSENT: 'CONSENT',
  ONE_TIME_NOTICE: 'ONE_TIME_NOTICE',
};

export const PrivacyCenterTabs = [{
  id: Ids.REQUEST_CENTER,
  label: 'Request Center',
}, {
  id: Ids.PREFERENCE_CENTER,
  label: 'Preference Center',
}];

export const FieldTypes = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  PARAGRAPH: 'PARAGRAPH',
  DOCUMENT: 'DOCUMENT',
  CPID: 'CPID',
  DROPDOWN: 'DROPDOWN',
};

export const DefaultFieldTypes = {
  CPID: 'CPID',
  EMAIL: 'EMAIL',
  NAME: 'NAME',
  DEFAULT: 'DEFAULT',
};

export const MimeTypes = {
  XLSX: 'application/vnd.ms-excel',
  DOCX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  HEIC: 'image/heic',
  PFX: 'application/x-pkcs12',
  PDF: 'application/pdf',
};

export const PurposeAction = {
  GRANT: 'grant',
  REVOKE: 'revoke',
};

export const GrantStatus = {
  GRANTED: 'GRANTED',
  REVOKED: 'REVOKED',
  NOT_GRANTED: 'NOT_GRANTED',
  INACTIVE: 'INACTIVE',
};

export const ModalIds = {
  CONSENT_CENTER_MODAL: 'CONSENT_CENTER_MODAL',
  PRIVACY_CENTER_MODAL: 'PRIVACY_CENTER_MODAL',
  RECORD_STATUS_HISTORY_MODAL: 'RECORD_STATUS_HISTORY_MODAL',
  REQUEST_CENTER_MODAL: 'REQUEST_CENTER_MODAL',
  COOKIE_CENTER_MODAL: 'COOKIE_CENTER_MODAL',
  COOKIE_NOTICE_MODAL: 'COOKIE_NOTICE_MODAL',
  COOKIE_PREFERENCE_MODAL: 'COOKIE_PREFERENCE_MODAL',
  COOKIE_LOCALE_MODAL: 'COOKIE_LOCALE_MODAL',
  INTERNAL_COMMENTS_MODAL: 'INTERNAL_COMMENTS_MODAL',
};

export const CenterTypes = {
  REQUEST_CENTER: 'requestCenterUrl',
  PREFERENCE_CENTER: 'preferenceCenterUrl',
  CONSENT_CENTER: 'consentCenterUrl',
  PRIVACY_CENTER: 'privacyCenterUrl',
  COOKIE_CENTER: 'cookieCenterUrl',
};

export const PreferenceDownloadTypes = [
  {
    id: 'notice',
    labelKey: 'DOWNLOAD_NOTICE_LABEL',
  },
  {
    id: 'Record',
    labelKey: 'DOWNLOAD_CONSENT_RECORD_LABEL',
  },
];

export const RequestTabsIds = {
  DETAILS: 'DETAILS',
  COMMUNICATIONS: 'COMMUNICATIONS',
};

export const RequestTabs = [
  { id: RequestTabsIds.DETAILS, label: 'Record Details' },
  { id: RequestTabsIds.COMMUNICATIONS, label: 'Communications' },
];
export const MappingResponseType = {
  VENDORS_PROCESSING_ACTIVITIES: 'VENDORS_PROCESSING_ACTIVITIES',
  PROCESSING_ACTIVITIES: 'PROCESSING_ACTIVITIES',
  DATA_CATEGORIES: 'DATA_CATEGORIES',
  VENDORS: 'VENDORS',
};

export const CookieNoticeStatus = {
  ALLOW_ALL: 'ALLOW_ALL',
  ALLOW_NECESSARY: 'ALLOW_NECESSARY',
  CUSTOMIZE: 'CUSTOMIZE',
};

// Two tiers, mirrored in consent-cookie-sdk.js. 768 is where the SDK forces the banner to
// full width and bottom; 480 is where the action buttons stack.
export const LANDSCAPE_MOBILE_BREAKPOINT = 768;
export const LARGE_MOBILE_BREAKPOINT = 480;

export const CookiePreferenceButtonIds = {
  ALLOW_NECESSARY: 'allowNecessary',
  ALLOW_ALL: 'allowAll',
  SAVE_PREFERENCES: 'savePreferences',
};

export const CookieAttributeRows = [
  { attribute: 'NAME', labelKey: 'COOKIE_LABEL', valueKey: 'name' },
  { attribute: 'DOMAIN', labelKey: 'COOKIE_SOURCE_LABEL', valueKey: 'originDomain' },
  { attribute: 'DESCRIPTION', labelKey: 'COOKIE_DESCRIPTION_LABEL', valueKey: 'description' },
  {
    attribute: 'PARTY_TYPE', labelKey: 'COOKIE_PARTY_TYPE_LABEL', valueKey: 'party', isEnum: true,
  },
];

export const EUNotificationTypes = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

export const AnswerTypes = {
  BOOLEAN: 'BOOLEAN',
  DROP_DOWN: 'DROP_DOWN',
  SCOPE: 'SCOPE',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  FILE: 'FILE',
  MULTI_SELECT_DROPDOWN: 'MULTI_SELECT_DROPDOWN',
};

// Reserved answer value for the free-text "Other" option on DROP_DOWN / MULTI_SELECT_DROPDOWN questions.
// Identified purely by value (matched trimmed, case-insensitive) — there is no boolean flag.
export const OTHER_OPTION_VALUE = 'Other';

export const AssessmentQuestionStatusTypes = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  ANSWERED: 'ANSWERED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const StyleCta = {
  CTA_COLOR: 'ctaColor',
  CTA_TEXT_COLOR: 'ctaTextColor',
};
export const ConfigKey = {
  HEADING: 'HEADING',
  DESCRIPTION: 'DESCRIPTION',
  BRAND_COLOR: 'BRAND_COLOR',
  CTA_TEXT_COLOR: 'CTA_TEXT_COLOR',
};

export const DefaultLocale = 'EN_IN';
export const ChannelLockType = {
  AMBER: 'AMBER',
  GRAY: 'GRAY',
};

// Canonical order in which communication channels are displayed everywhere
// (chip strips, profile banners, preference views). Any new channel goes here.
export const CHANNEL_ORDER = ['EMAIL', 'SMS', 'WHATSAPP', 'VOICE', 'IN_APP_NOTIFICATION'];

// Channel → react-feather icon name. Values must match keys exported by
// `IconKeys` from `@components/icon` (which is derived from `react-feather`).
// Kept as string literals so this file doesn't need to import from components.
export const CHANNEL_ICONS = {
  EMAIL: 'Mail',
  SMS: 'MessageSquare',
  WHATSAPP: 'MessageCircle',
  VOICE: 'Phone',
  IN_APP_NOTIFICATION: 'Bell',
};
